import { useEffect, useRef } from "react";

declare global {
  interface Window {
    BTRenderer: any;
  }
}

export function SportsWidget() {
  const containerRef = useRef<HTMLDivElement>(null);
  const btRendererRef = useRef<any>(null);

  useEffect(() => {
    let isCancelled = false;
    const containerEl = containerRef.current;

    const scriptSrc = "https://ui.invisiblesport.com/bt-renderer.min.js";
    const existingScript = document.querySelector<HTMLScriptElement>(
      `script[src="${scriptSrc}"]`
    );

    const script =
      existingScript ?? (document.createElement("script") as HTMLScriptElement);
    if (!existingScript) {
      script.src = scriptSrc;
      script.async = true;
      script.dataset.btRenderer = "true";
    }

    const init = () => {
      if (isCancelled) return;
      if (!window.BTRenderer || !containerEl) return;


      if (btRendererRef.current) return;

      btRendererRef.current = new window.BTRenderer().initialize({
        brand_id: "2139372403766206464",
        lang: "en",
        target: containerEl,
        themeName: "light",
        widgetName: "promo",
        widgetParams: {
          placeholder: "home_top",
          withSportsList: true,
          onBannerClick: () => {
            window.location.href = `${window.location.origin}/sportsbookplus`;
          },
          onSportClick: () => {
            window.location.href = `${window.location.origin}/sportsbookplus`;
          },
        },
      });
    };

    init();

    const onLoad = () => init();
    script.addEventListener("load", onLoad);

    if (!existingScript) {
      document.body.appendChild(script);
    }

    return () => {
      isCancelled = true;
      script.removeEventListener("load", onLoad);

      const instance = btRendererRef.current;
      btRendererRef.current = null;

      if (instance) {
        if (typeof instance.destroy === "function") instance.destroy();

        if (typeof instance.kill === "function") instance.kill();
      }


      if (containerEl) {
        const el = containerEl;
        queueMicrotask(() => {
          if (!el.isConnected) return;
          el.replaceChildren();
        });
      }
    };
  }, []);

  return (
    <div className="sportsbook_section_wrapper p-2 mt-3 ">
      <div id="sal-sports-events" ref={containerRef}></div>
    </div>
  );
}

export default SportsWidget;
